<template>
  <div class="main">

    <div class="main-content not-found">
      <div class="header">
        <img src="../assets/img/easytick.png" width="180">
      </div>
      <div class="body">
        <h1>Página não encontrada</h1>
        <icon name="plug" scale="15"></icon>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
